<p>e-edit-profile works!</p>

<link rel="stylesheet" href="//use.fontawesome.com/releases/v5.0.7/css/all.css">
<script src="https://use.fontawesome.com/29ecae9da7.js"></script>

<div class="edit-address" >
     <div class="address-left" >
        
        <h1 style="font-size: 24px;">MY ACCOUNT</h1>
        <li>Account information</li>
        <a class="order" >My Orders</a>
        <a class="logout" >Log out</a>
     </div><!--end left-->

     <div class="vl" ></div>

     <div class="address-right" >
        <p>Contact Information</p>
        <input type="text" class="inputbox" name="adress1" placeholder="First name"><br>
        <input type="text" class="inputbox" name="adress1" placeholder="Last name"><br>
        <input type="text" class="inputbox" name="adress1" placeholder="Email address"><br>
        <input type="text" class="inputbox" name="adress1" placeholder="Phone no."><br>
        <button>Save</button>
     </div><!--end right-->
</div><!--end edit address-->

